var StyledScroll = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_styled_scroll',
		type: 'v', // could be 'h' for horisontal or 'v' for vertical
		scrolling_speed: 30,
		min_dragger_size: 50,
		max_height: null,
		element_position: 0 // where to stop page scrolling (-1 - don't stop, 0 - top of the window, 'auto' - not set)
	},

	initialize: function(element, options) {
		this.setOptions(options);
		this._element = element || document.getElement('.' + this.options.cls);

		if (this._element) {
			this.build();
		}
	},

	build: function() {
		var self = this;
		var opts = this.options;

		this._container = new Element('div', {'class': opts.cls + ' _' + opts.type}).inject(this._element, 'before');

		if (opts.max_height) {
			this._container.setStyle('max-height', opts.max_height);
		}

		this._element.removeClass(opts.cls);
		this._element.inject(this._container);

		this.el_size = this._element.getSize();

		if ((opts.type === 'v' && this.el_size.y <= this._container.getSize().y) ||
				(opts.type === 'h' && this.el_size.x <= this._container.getSize().x)) return;

		this._scroller = new Element('div', {'class': 'scroller', 'html': '<div class="dragger">&nbsp;</div>'}).inject(this._container);

		this.set_dragger_size();
		this.set_dragger_limits();
		this.add_dragger_events();

		if (opts.type === 'v') {
			this.space = this._scroller.getSize().y - this._dragger.getSize().y;
			this.diff = this.el_size.y - this._container.getSize().y;

			this.dragger_prop = 'top';
			this.element_prop = 'margin-top';
		} else {
			this.space = this._scroller.getSize().x - this._dragger.getSize().x;
			this.diff = this.el_size.x - this._container.getSize().x;
			this.dragger_prop = 'left';
			this.element_prop = 'margin-left';
		}

		this.add_scroller_events();

		this.add_body_events();

		this._container.addEvent('mousewheel', function(e) {
			var pos;
			e = e || window.event;

			if (self._container.hasClass('_no_scrolling')) {
				return;
			}

			if (self._element.getStyle(self.element_prop).toInt() === e.wheel) {
				return;
			}

			// for IE
			if (e.returnValue) {
				e.returnValue = false;
			}

			e.stopPropagation();
			e.preventDefault();

			if (e.wheel > 0) {
				pos = self._element.getStyle(self.element_prop).toInt() + opts.scrolling_speed;

				if (pos < 0) {
					if (e && e.stop) e.stop();
				}

				pos = (pos >= 0) ? 0 : pos;
			} else {
				pos = self._element.getStyle(self.element_prop).toInt() - opts.scrolling_speed;

				if (pos > self.diff * -1) {
					if (e && e.stop) e.stop();
				} else {
					pos = self.diff * -1;
				}
			}

			if (self._element.getStyle(self.element_prop).toInt() !== pos) {
				self.fireEvent('scrolling');
			}

			self._element.setStyle(self.element_prop, pos);
			self.set_dragger_position(pos);
		});

		if (opts.type === 'v') {
			this.add_anchors_support();
		}

		if (Core.is_touch_supported()) {
			this.add_touch_devices_support();
		}
	},

	add_scroller_events: function() {
		var self = this;
		var opts = this.options;
		var event_pos, pos;

		this._scroller.addEvents({
			mousedown: function(e) {
				if (self.indragger) return;

				if (opts.type === 'v') {
					event_pos = e.page.y - self._scroller.getPosition().y;
				} else {
					event_pos = e.page.x - self._scroller.getPosition().x;
				}

				if (event_pos > self._dragger.getStyle(self.dragger_prop).toInt()) {
					pos = event_pos - self.dragger_size;
				} else {
					pos = event_pos;
				}

				self.dragging = true;

				self._dragger.setStyle(self.dragger_prop, pos);
				self.set_element_position(pos);
			},

			mouseup: function() {
				self.dragging = false;
			}
		});
	},

	set_dragger_size: function() {
		var opts = this.options;
		var _dragger = this._dragger = this._scroller.getElement('.dragger');
		var size_coefficient, scr_size, style;

		if (opts.type === 'v') {
			size_coefficient = this.el_size.y / this._container.getSize().y;
			scr_size = this._scroller.getSize().y;
			style = 'height';
		} else {
			size_coefficient =	this.el_size.x / this._container.getSize().x;
			scr_size = this._scroller.getSize().x;
			style = 'width';
		}

		if (size_coefficient > 20) {
			size_coefficient = 20;
		} else if (size_coefficient < 2) {
			size_coefficient = 2;
		}

		this.dragger_size = scr_size / size_coefficient;

		if (this.dragger_size < opts.min_dragger_size) {
			this.dragger_size = opts.min_dragger_size;
		}

		_dragger.setStyle(style, this.dragger_size);
	},

	set_dragger_limits: function() {
		var opts = this.options;

		if (opts.type === 'v') {
			this._dragger.max_top = 0;
			this._dragger.max_bottom = this._scroller.getSize().y - this._dragger.getSize().y;
		} else {
			this._dragger.max_left = 0;
			this._dragger.max_right = this._scroller.getSize().x - this._dragger.getSize().x;
		}
	},

	add_dragger_events: function() {
		var self = this;
		var opts = this.options;

		this._dragger.addEvents({
			mousedown: function(e) {
				self.dragging = true;

				if (opts.type === 'v') {
					self._dragger.top_pos = self._dragger.getStyle('top').toInt();
					self.init_pos = e.page.y;
				} else {
					self._dragger.left_pos = self._dragger.getStyle('left').toInt();
					self.init_pos = e.page.x;
				}

				self._scroller.addClass('_on_hold');

				return false;
			},
			mouseenter: function() {
				self.indragger = true;
			},
			mouseleave: function() {
				self.indragger = false;
			}
		});
	},

	add_body_events: function() {
		var self = this;
		var opts = this.options;

		$(document.body).addEvents({
			mousemove: function(e) {
				if (!self.dragging) return;

				var move, pos, space, diff;

				if (opts.type === 'v') {
					move = e.page.y - self.init_pos;
					pos = self._dragger.top_pos + move;

					if (pos < self._dragger.max_top) {
						pos = self._dragger.max_top;
					} else if (pos > self._dragger.max_bottom) {
						pos = self._dragger.max_bottom;
					}

					self._dragger.setStyle('top', pos);
				} else {
					move = e.page.x - self.init_pos;
					pos = self._dragger.left_pos + move;

					if (pos < self._dragger.max_left) {
						pos = self._dragger.max_left;
					} else if (pos > self._dragger.max_right) {
						pos = self._dragger.max_right;
					}

					self._dragger.setStyle('left', pos);
				}

				if (self._element.getStyle(self.element_prop).toInt() !== pos) {
					self.fireEvent('scrolling');
				}

				self.set_element_position(pos);
			},

			mouseleave: function() {
				self.dragging = false;
			},

			mouseup: function() {
				self.dragging = false;
				self._scroller.removeClass('_on_hold');
			}
		});
	},

	set_dragger_position: function(pos) {
		this._dragger.setStyle(this.dragger_prop, pos / (this.diff / this.space) * -1);
	},

	set_element_position: function(pos) {
		this._element.setStyle(this.element_prop, pos * (this.diff / this.space) * -1);
	},

	add_anchors_support: function() {
		var self = this;

		this._element.addEvent('click:relay(a)', function(e, _el) {
			var href = _el.get('href');

			if (!href || href === '' || href === '#') return;

			var first_char = href.substring(0, 1);

			if (first_char !== '#') return;

			var name = href.substring(1);

			var _anchor = self._element.getElement('[name="' + name + '"]');

			if (_anchor) {
				if (e && e.stop) e.stop();

				var pos = _anchor.getPosition(self._element).y * -1;

				self._element.setStyle(self.element_prop, pos);
				self.set_dragger_position(pos);
			}
		});
	},

	add_touch_devices_support: function() {
		var self = this;
		var in_element = false;
		var prev_touch_pos;
		var current_touch_pos;
		var new_pos;

		this._element.addEvents({
			touchstart: function(e) {
				in_element = true;
			},

			touchend: function(e) {
				in_element = false;
				prev_touch_pos = undefined;
			},

			touchmove: function(e) {
				current_touch_pos = (self.options.type === 'v') ? e.targetTouches[0].pageY : e.targetTouches[0].pageX;
				prev_touch_pos = prev_touch_pos || current_touch_pos;

				new_pos = self._element.getStyle(self.element_prop).toInt() + (current_touch_pos - prev_touch_pos);

				if (new_pos > 0) {
					new_pos = 0;
				} else if (new_pos < self.diff * -1) {
					new_pos = self.diff * -1;
				}

				self._element.setStyle(self.element_prop, new_pos);
				self.set_dragger_position(new_pos);

				prev_touch_pos = current_touch_pos;
			}
		});

		$(document.body).addEvents({
			touchmove: function(e) {
				return !in_element;
			}
		});
	}
});
